import React from 'react'
import { Loader } from 'semantic-ui-react'

const FullPageSpinner: React.FC = () => <Loader active size="massive" />

export default FullPageSpinner
